import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroSection } from './IntroSection';
import { ScheduleFees } from './ScheduleFees';
import { ProgramDetails } from './ProgramDetails';
import { GettingStarted } from './GettingStarted';
import { QuickLinks } from './QuickLinks';
export function JrRiflePage() {
  return <PageLayout data-id="element-2034">
      <HeaderBanner data-id="element-2035" />
      <IntroSection data-id="element-2036" />
      <ScheduleFees data-id="element-2037" />
      <ProgramDetails data-id="element-2038" />
      <GettingStarted data-id="element-2039" />
      <QuickLinks data-id="element-2040" />
    </PageLayout>;
}